// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import refs from '../helpers/refs'
import TabTrap from '../helpers/tab-trap'

class CVideoOverlay {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    this.tabTrap = new TabTrap(this.$root)

    this.index = null
    this.list = []

    this.createList()

    if (this.list.length > 1) {
      this.renderList()
    }

    this.$refs.close.addEventListener('click', () => {
      this.hideOverlay()
    })

    document.addEventListener('keyup', (e) => {
      if (this.$root.classList.contains('--show') && e.code === 'Escape') {
        this.hideOverlay()
      }
    })
  }

  destroyItem () {
    while (this.$refs.item.lastChild) {
      this.$refs.item.lastChild.remove()
    }
  }

  hideOverlay () {
    // enableBodyScroll(this.$root)
    this.$root.classList.remove('--show')
    this.$root.hidden = true

    // Unpause any background videos
    document
      .querySelectorAll('.a-video-video .a-video-video__bg-video')
      .forEach((video) => {
        video.play()
      })

    this.destroyItem()
    this.index = null
    this.tabTrap.destroyEvents()
  }

  showOverlay () {
    // disableBodyScroll(this.$root)
    this.$root.classList.add('--show')

    // Add a hidden attribute to avoid tabbing to the overlay when it's hidden
    this.$root.hidden = false
  }

  createList () {
    document.querySelectorAll('[data-video-overlay]').forEach((node, index) => {
      this.list[index] = {
        group: node.dataset.videoOverlayGroup === 'true',
        image: node.dataset.videoOverlayImage || '',
        title: node.dataset.videoOverlayTitle || '',
        video: node.dataset.videoOverlayVideo || ''
      }

      node.addEventListener('click', (e) => {
        this.showOverlay()
        this.renderItem(index)
        this.tabTrap.initEvents()

        // Pause any background videos autoplaying
        document
          .querySelectorAll('.a-video-video .a-video-video__bg-video')
          .forEach((video) => {
            video.pause()
          })
      })
    })
  }

  renderList () {
    this.list
      .filter(item => item.group)
      .forEach((item, index) => {
        const $button = document.createElement('button')
        $button.classList.add('c-video-overlay__list-button')

        const $image = document.createElement('img')
        $image.classList.add('c-video-overlay__list-image')
        $image.alt = item.title
        $image.src = item.image
        $button.append($image)

        const $title = document.createElement('div')
        $title.classList.add('c-video-overlay__list-title')
        $title.innerText = item.title
        $button.append($title)

        $button.addEventListener('click', (e) => {
          // Handle iOS Safari's buggy click event behavior
          e.preventDefault()
          e.stopPropagation()

          this.renderItem(index)
        })

        this.$refs.list.append($button)
      })
  }

  renderItem (index) {
    if (this.index !== index) {
      this.destroyItem()
      this.index = index

      this.$refs.list.childNodes.forEach((node, i) => {
        node.classList.toggle('--active', i === index)
      })

      const item = this.list[index]

      const $ratio = document.createElement('div')
      $ratio.classList.add('o-aspect-ratio', 'o-aspect-ratio--16:9')

      if (/youtube|vimeo/.test(item.video)) {
        const $video = document.createElement('iframe')
        $video.classList.add('c-video-overlay__video')
        $video.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        $video.allowfullscreen = true
        $video.frameborder = 0
        $video.src = item.video
        $video.title = item.title
        $ratio.append($video)
      } else {
        const $video = document.createElement('video')
        $video.classList.add('c-video-overlay__video')
        $video.controls = true
        $video.playsinline = true
        $video.src = item.video
        $video.title = item.title
        $ratio.append($video)

        setTimeout(() => {
          $video.play()
        }, 100)
      }

      const $title = document.createElement('h5')
      $title.classList.add('c-video-overlay__title')
      $title.innerText = item.title

      this.$refs.item.append($ratio)
      this.$refs.item.append($title)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-video-overlay')
    .forEach(el => new CVideoOverlay(el))
})
